/*
 * Column-aware paging for the featured-collection paged grid.
 *
 * The grid flows its cards into columns with `grid-auto-flow: column`, so the
 * number of rows is a CSS decision and can differ per breakpoint. The cost is
 * that consecutive cards usually sit in the SAME column: Dawn's SliderComponent
 * measures its step as `items[1].offsetLeft - items[0].offsetLeft`, which is 0
 * for stacked cards and leaves the arrows dead.
 *
 * This replaces initPages on those components with a version that steps by the
 * distance to the first card of the NEXT column, and counts pages in columns
 * rather than cards. Everything else - scroll handling, disabled states, the
 * ResizeObserver - is left to SliderComponent, which calls this.initPages() and
 * so picks up the override on every resize and breakpoint change.
 */
(function () {
  if (window.pagedGridSliderInit) return;

  function columnAwareInitPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(function (element) {
      return element.clientWidth > 0;
    });
    if (this.sliderItemsToShow.length < 2) return;

    var firstLeft = this.sliderItemsToShow[0].offsetLeft;
    var nextColumn = this.sliderItemsToShow.find(function (element) {
      return element.offsetLeft > firstLeft;
    });

    // One column tall enough to hold everything means there is no next column
    // to measure against; fall back to the card's own width.
    this.sliderItemOffset = nextColumn
      ? nextColumn.offsetLeft - firstLeft
      : this.sliderItemsToShow[0].clientWidth;

    var columnCount = new Set(
      this.sliderItemsToShow.map(function (element) {
        return element.offsetLeft;
      })
    ).size;

    this.slidesPerPage = Math.floor((this.slider.clientWidth - firstLeft) / this.sliderItemOffset);
    if (this.slidesPerPage < 1) this.slidesPerPage = 1;
    this.totalPages = Math.max(columnCount - this.slidesPerPage + 1, 1);

    this.update();
  }

  function patch(component) {
    if (!component.slider || !component.nextButton) return;
    // An own property shadows the prototype, so the ResizeObserver installed by
    // the constructor calls this version from here on.
    component.initPages = columnAwareInitPages;
    component.initPages();
  }

  function init() {
    document.querySelectorAll('slider-component[data-paged-grid]').forEach(patch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-patch sections re-rendered by the theme editor.
  document.addEventListener('shopify:section:load', init);

  window.pagedGridSliderInit = true;
})();
